import { createAction } from 'redux-actions';
import {
    API_GRADE,
} from 'constants/endpoints';
import { StatusEnum } from 'flex/actions/http/StatusEnum';

/**
 * Prefix 付きの ActionType を作成する
 */
const createActionType = <ActionType extends string>(actionType: ActionType) => {
    const prefix = 'CONNECTION/GRADE';
    return `${prefix}/${actionType}` as `${typeof prefix}/${ActionType}`;
}

type DefaultPayload = { method: HttpMethods, api: string };
type DefaultMeta = { fetch: boolean, status: RequestStatus };

type Payload<EXTRA extends object = Record<string, never>> =
    EXTRA extends Record<string, never>
        ? DefaultPayload
        : Expand<DefaultPayload & EXTRA>;
type Meta<EXTRA extends object = Record<string, never>> =
    EXTRA extends Record<string, never>
        ? DefaultMeta
        : Expand<DefaultMeta & EXTRA>;


export const search = createAction<
    Payload | Http.Connection.Response.Grade.Search,
    Meta
>(
    createActionType('SEARCH' as const),
    () => {
        return ({ method: 'get', data: { page_size: 30 }, api: `${API_GRADE}/1` })
    },
    () => ({ fetch: true, status: StatusEnum.REQUEST })
);